var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import Label from '../Label';
import formTheme from '../theme';
import { ComponentThemeProvider } from '../../ThemeProvider';
import Skeleton, { withSkeleton } from '../../Skeleton';
var StyledLabel = styled(Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  span.first {\n    padding-right: 0.25rem;\n  }\n\n  span.second {\n    flex-grow: 1;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  span.first {\n    padding-right: 0.25rem;\n  }\n\n  span.second {\n    flex-grow: 1;\n  }\n"])));
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 100%;\n  outline: none;\n  appearance: none;\n  position: relative;\n\n  &:focus,\n  &.focus {\n    border-width: 2px;\n    border-color: ", ";\n    &:checked {\n      &::after {\n        top: 0.125rem;\n        left: 0.125rem;\n      }\n    }\n  }\n\n  &:checked {\n    &::after {\n      position: relative;\n      top: 0.1875rem;\n      left: 0.1875rem;\n      display: block;\n      width: 0.5rem;\n      height: 0.5rem;\n      background: ", ";\n      border-radius: 50%;\n      content: '';\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n    &:checked {\n      &::after {\n        background-color: ", ";\n      }\n    }\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 100%;\n  outline: none;\n  appearance: none;\n  position: relative;\n\n  &:focus,\n  &.focus {\n    border-width: 2px;\n    border-color: ", ";\n    &:checked {\n      &::after {\n        top: 0.125rem;\n        left: 0.125rem;\n      }\n    }\n  }\n\n  &:checked {\n    &::after {\n      position: relative;\n      top: 0.1875rem;\n      left: 0.1875rem;\n      display: block;\n      width: 0.5rem;\n      height: 0.5rem;\n      background: ", ";\n      border-radius: 50%;\n      content: '';\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n  &:disabled {\n    background-color: ",
    ";\n    border-color: ", ";\n    &:checked {\n      &::after {\n        background-color: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.radio.width;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.height;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.backgroundColor.normal;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.focus.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.disabled.backgroundColor;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.disabled.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.radio.disabled.color;
});
/**
 * Radio
 */
export var Radio = function (_a) {
    var className = _a.className, label = _a.label, disabled = _a.disabled, props = __rest(_a, ["className", "label", "disabled"]);
    // no idea how to destructure a name with a - inside
    // @ts-ignore
    // eslint-disable-next-line react/destructuring-assignment
    var testid = props['data-testid'];
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement(StyledLabel, { className: className, inline: true, disabled: disabled },
            React.createElement("span", { className: "first" },
                React.createElement(Input, __assign({ type: "radio", disabled: disabled }, props, { className: className, "data-testid": testid }))),
            React.createElement("span", { className: "second" }, label))));
};
export var RadioSkeleton = function () { return (React.createElement(ComponentThemeProvider, { theme: formTheme },
    React.createElement(Label, { inline: true },
        React.createElement(Input, { type: "radio" }),
        React.createElement(Skeleton, { height: "1.125rem", inline: true, width: "70%" })))); };
export default withSkeleton(Radio, RadioSkeleton);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map